export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/bigcommerce.700ca35.svg";